const DEPLOYED_VERSION_FILE = "/version.json";

/**
 * Parse a version string that match semantic versioning (semver) format into an array of numbers. Ignores the pre-release and build metadata parts of the version string.
 * If the version string is invalid, return null.
 *
 *
 *
 * @param version
 * @returns
 */
const parseVersion = (version: string | undefined): number[] | null => {
  if (!version) {
    return null;
  }

  // Regex matching semver RFC : https://semver.org/
  const res =
    /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/.exec(
      version
    );
  if (!res) {
    return null;
  }

  return res.slice(1, 4).map(part => Number(part));
};

export const isNewerVersion = (
  deployedVersion: string | undefined,
  runningVersion: string | undefined
): boolean => {
  const deployed = parseVersion(deployedVersion);
  const running = parseVersion(runningVersion);

  if (!deployed || !running) {
    return false;
  }

  for (
    let index = 0;
    index < Math.max(deployed.length, running.length);
    index++
  ) {
    const deployedNumber = deployed[index] ?? 0;
    const runningNumber = running[index] ?? 0;

    if (deployedNumber !== runningNumber) {
      return deployedNumber > runningNumber;
    }
  }

  return false;
};

export const getRunningAppVersion = (): string | undefined =>
  import.meta.env.VITE_APP_VERSION;

export const fetchDeployedAppVersion = async (): Promise<
  string | undefined
> => {
  const response = await fetch(
    `${window.location.origin}${DEPLOYED_VERSION_FILE}`,
    { cache: "no-store" }
  );

  if (!response.ok) {
    return undefined;
  }

  const { version } = await response.json();

  return typeof version === "string" ? version : undefined;
};
